/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'dashboard',
    },
    {
        id: 'codes',
        title: 'Code',
        type: 'basic',
        icon: 'heroicons_outline:code-bracket-square',
        link: 'codes'
    },
    {
        id: 'events',
        title: 'Events',
        type: 'aside',
        icon: 'mat_outline:event_note',
        children: [
            {
                id: 'events.trace',
                title: 'Trace',
                type: 'basic',
                icon: 'mat_outline:track_changes',
                link: 'events/trace'
            },
            {
                id: 'events.track',
                title: 'Track',
                type: 'basic',
                icon: 'mat_outline:cable',
                link: 'events/track'
            },
            {
                id: 'events.hierarchy',
                title: 'Hierarchy',
                type: 'basic',
                icon: 'mat_outline:account_tree',
                link: 'events/hierarchy'
            },
            {
                id: 'events.issues',
                title: 'Issues',
                type: 'basic',
                icon: 'mat_outline:report_problem',
                link: 'events/issues'
            }
        ]
    },
    {
        id: 'devices',
        title: 'Devices',
        type: 'basic',
        icon: 'mat_outline:devices',
        link: 'devices'
    },

    // {
    //     id: 'team',
    //     title: 'Team',
    //     type: 'basic',
    //     icon: 'heroicons_outline:users',
    //     link: 'team'
    // },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'heroicons_outline:document-chart-bar',
        link: 'reporting'
    },
    {
        id: 'apps',
        title: 'Apps',
        subtitle: 'Apps',
        type: 'aside',
        icon: 'mat_outline:apps',
        children: [
            {
                id: 'apps.distribution',
                title: 'Distribution',
                type: 'basic',
                icon: 'mat_outline:map',
                link: 'apps/distribution'
            },
            {
                id: 'apps.product',
                title: 'Products',
                type: 'basic',
                icon: 'heroicons_outline:circle-stack',
                link: 'apps/products'
            },
            {
                id: 'apps.aggregation',
                title: 'Aggregation',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-group',
                link: 'apps/aggregation'
            },
            {
                id: 'apps.serialization',
                title: 'Serialization',
                type: 'basic',
                icon: 'feather:external-link',
                link: 'apps/serialization'
            },
            {
                id: 'apps.warehouse',
                title: 'Warehouse',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: 'apps/warehouse'
            },
            {
                id: 'apps.inventory',
                title: 'Inventory',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: 'apps/inventory'
            },
            {
                id: "apps.exturbanfarm",
                title: "Farming",
                type: "basic",
                icon: "feather:external-link",
                link: "apps/urbanfarm"
            },
            {
                id: "apps.exttransport",
                title: "Transportation",
                type: "basic",
                icon: "feather:external-link",
                link: "apps/transport"
            }
        ],
    },
    {
        id: 'setting',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: 'settings'
    }
];

export const compactAccNavigation: FuseNavigationItem[] = [
    {
        id: 'profile',
        title: 'My Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/account/profile'
    },
    {
        id: 'security',
        title: 'Security',
        type: 'basic',
        icon: 'heroicons_outline:lock-closed',
        link: '/account/security'
    },
    {
        id: 'mycompany',
        title: 'Company',
        type: 'basic',
        icon: 'mat_outline:business',
        link: '/account/mycompany'
    },

];

export const compactAppNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'dashboard',
    },
    {
        id: 'project',
        title: 'Projects',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: 'projects'
    },
    {
        id: 'companies',
        title: 'Companies',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: 'companies'
    },
    {
        id: 'code',
        title: 'Code',
        type: 'basic',
        icon: 'mat_outline:code',
        link: 'code'
    },
    {
        id: 'masterdata',
        title: 'Master Data',
        type: 'basic',
        icon: 'heroicons_outline:code-bracket-square',
        link: 'masterdata'
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'basic',
        icon: 'mat_outline:settings_applications',
        link: 'apps'
    },
    {
        id: 'events',
        title: 'Events',
        type: 'aside',
        icon: 'mat_outline:event_note',
        children: [
            {
                id: 'events.trace',
                title: 'Trace',
                type: 'basic',
                icon: 'mat_outline:track_changes',
                link: 'events/trace'
            },
            {
                id: 'events.track',
                title: 'Track',
                type: 'basic',
                icon: 'mat_outline:cable',
                link: 'events/track'
            },
            {
                id: 'events.hierarchy',
                title: 'Hierarchy',
                type: 'basic',
                icon: 'mat_outline:account_tree',
                link: 'events/hierarchy'
            },
            {
                id: 'events.issues',
                title: 'Issues',
                type: 'basic',
                icon: 'mat_outline:report_problem',
                link: 'events/issues'
            }
        ]
    },
];

export const compactCompanyNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'dashboard',
    },
    {
        id: 'detail',
        title: 'Details',
        type: 'basic',
        icon: 'mat_outline:info',
        link: 'detail'
    },
    {
        id: 'site',
        title: 'Sites',
        type: 'basic',
        icon: 'mat_outline:store',
        link: 'sites'
    },
    {
        id: 'events',
        title: 'Events',
        type: 'aside',
        icon: 'mat_outline:event_note',
        children: [
            {
                id: 'events.trace',
                title: 'Trace',
                type: 'basic',
                icon: 'mat_outline:track_changes',
                link: 'events/trace'
            },
            {
                id: 'events.track',
                title: 'Track',
                type: 'basic',
                icon: 'mat_outline:cable',
                link: 'events/track'
            },
            {
                id: 'events.hierarchy',
                title: 'Hierarchy',
                type: 'basic',
                icon: 'mat_outline:account_tree',
                link: 'events/hierarchy'
            },
            {
                id: 'events.issues',
                title: 'Issues',
                type: 'basic',
                icon: 'mat_outline:report_problem',
                link: 'events/issues'
            }
        ]
    },
    {
        id: 'codes',
        title: 'Code',
        type: 'basic',
        icon: 'heroicons_outline:code-bracket-square',
        link: 'codes'
    },
    {
        id: 'product',
        title: 'Products',
        type: 'basic',
        icon: 'mat_outline:folder',
        link: 'products'
    },
    {
        id: 'epcclass',
        title: 'EPC Classes',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: 'epcclass'
    },
    {
        id: 'setting',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: 'settings'
    }
];

export const compactProjectNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'dashboard',
    },
    {
        id: 'detail',
        title: 'Details',
        type: 'basic',
        icon: 'mat_outline:info',
        link: 'detail'
    },
    {
        id: 'events',
        title: 'Events',
        type: 'aside',
        icon: 'mat_outline:event_note',
        children: [
            {
                id: 'events.trace',
                title: 'Trace',
                type: 'basic',
                icon: 'mat_outline:track_changes',
                link: 'events/trace'
            },
            {
                id: 'events.track',
                title: 'Track',
                type: 'basic',
                icon: 'mat_outline:cable',
                link: 'events/track'
            },
            {
                id: 'events.hierarchy',
                title: 'Hierarchy',
                type: 'basic',
                icon: 'mat_outline:account_tree',
                link: 'events/hierarchy'
            },
            {
                id: 'events.issues',
                title: 'Issues',
                type: 'basic',
                icon: 'mat_outline:report_problem',
                link: 'events/issues'
            }
        ]
    },
    {
        id: 'company',
        title: 'Companies',
        type: 'basic',
        icon: 'mat_outline:store',
        link: 'companies'
    },
    // {
    //     id: 'site',
    //     title: 'Site',
    //     type: 'basic',
    //     icon: 'mat_outline:store',
    //     link: 'sites'
    // },
    {
        id: 'code',
        title: 'Code',
        type: 'basic',
        icon: 'mat_outline:code',
        link: 'code'
    },
    {
        id: 'masterdata',
        title: 'Master Data',
        type: 'basic',
        icon: 'heroicons_outline:code-bracket-square',
        link: 'masterdata'
    },
    {
        id: 'setting',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: 'settings'
    }
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
